
document.addEventListener('click', async function (event) {
  const button = event.target.closest('.compatible-cartridge-add');

  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;

  if (!variantId) return;

  const originalText = button.textContent.trim();

  button.disabled = true;
  button.textContent = 'Adding…';

  try {
    const response = await fetch(
      `${Shopify.routes.cart_add_url}.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description || result.message || 'Unable to add this product.'
      );
    }

    button.textContent = 'Added!';

    // Refresh the storefront so the cart reflects Shopify's latest state.
    window.location.reload();

  } catch (error) {
    console.error('Compatible cartridge add-to-cart error:', error);

    button.disabled = false;
    button.textContent = originalText;
    window.alert(
      error.message || 'Could not add this cartridge. Please try again.'
    );
  }
});
